<template>
   <div>
   <div>
       <!-- <button class="uk-button uk-button-default" type="button" uk-toggle="target: #offcanvas-flip">Open</button> -->
<div id="offcanvas-flip" uk-offcanvas="flip: true; overlay: true">
    <div class="uk-offcanvas-bar">
        <button class="uk-offcanvas-close sidebar_close" type="button" uk-close>
            <ion-icon name="close-circle-sharp" ></ion-icon>
        </button>
        <!-- til betaling  -->
          <template v-if="get_sub_total==0">
               <div class="cart_empty">
                    <img src="@/assets/emptycart.svg" alt="">
                     <p>{{get_local_string.string_111}}</p>
                     <b-button tag="router-link" to="/"  uk-toggle="target: #offcanvas-flip" type="is-success">{{get_local_string.string_106}}</b-button>
               </div>
            </template>
            <template v-else-if="all_data_cart.status==402">
                <div class="colsed_wrap">
                    <img src="@/assets/closed.png" alt="">
                </div>
            </template>
            <template v-else>
                  <div   :class="['list_added_item', (get_coupon_object.is_apply!=1  ? 'side_in' : '')]" >
                <span class="single_side"  v-for="(sideitem , index) in get_data_cart" :key="sideitem.item_id">
            <div class="move_left move_left_side" :price_data="sideitem.price" :qty="sideitem.quantity">
                <img v-if="sideitem" :src="sideitem.image" alt="">
                  <b-field class="d-inline-block">
            <b-select v-model="sideitem.quantity" @input.native="updateItem(sideitem , $event)" class="qty_side" name="" id="" >
                 <option :value="0" >0</option>
                  <template v-for="qty in sideitem.quantity+3" >
                        <option :value="qty" :key="qty.id">{{qty}}</option>
                      </template>
            </b-select>
        </b-field>
                <span  class="name_side">
                 <template v-if="sideitem.data.length==1">
                      <span v-for="tilbud_item in sideitem.data" :key="tilbud_item.id">
                     {{tilbud_item.name}}
                 </span>
                 </template>
                 <template v-else>
                     <div class="flex_tilbud_side">
                          <strong>{{sideitem.name}}</strong>
                          <span v-for="tilbud_item in sideitem.data" :key="tilbud_item.id">
                     {{tilbud_item.name}}
                 </span>
                     </div>
                 </template>
                
                  <br>
                 <span class="type_food">
                 {{sideitem.size}} -
                 {{sideitem.dough}} 
                 </span>
                 
             </span>
            <span  class="price_side"> <span :class="[(get_coupon_object.is_apply==1 ? 'red_price_side' : '')]">{{sideitem.final_price}}{{get_setting_app.payment.currency}}</span> <del v-show="get_coupon_object.is_apply==1">{{sideitem.price}}{{get_setting_app.payment.currency}} </del> </span>
            <aside>
                <b-field class="d-inline-block">
            <b-select v-model="sideitem.quantity" @input.native="updateItem(sideitem , $event)" class="qty_side" name="" id="" >
                  <template v-for="qty in sideitem.quantity+3" >
                        <option :value="qty" :key="qty.id">{{qty}}</option>
                      </template>
            </b-select>
        </b-field>
         <b-button type="is-danger" :id="`del-${index+1}`"  @click="delteItem(sideitem , index+1)" class="remove_item"
               icon-right="delete" />
                 <!-- <button ><i class="fas fa-trash-alt"></i></button> -->
            </aside>
             <b-button type="is-danger" :id="`del-${index+1}`"  @click="delteItem(sideitem , index+1)" class="remove_item abs_delete"
               icon-right="delete" />
            </div>
           
                  </span>
         <!--  -->
        </div>
            <div class="stky_div">
                <div class="discount_side">
             <b-field type="is-success" v-show="get_coupon_object.is_apply!=1">
            <b-input class="input_code"  placeholder="Coupon Code .."  v-model="couopn_input"
                    couopn_input = get_coupon_object.code
                icon="tag-heart" >
            </b-input>
            <p class="control">
                <b-button v-if="get_coupon_object.is_apply!=1" @click.prevent="apply_coupon_code()" :label="get_local_string.string_27" type="is-success" />
                 <b-button class="remove_code" v-if="get_coupon_object.is_apply==1" @click.prevent="remove_coupon_code()" type="is-danger">
                   <ion-icon name="close-sharp"></ion-icon>
                     </b-button>   
            </p>
        </b-field>
        </div>
         <a v-show="get_coupon_object.is_apply==1" class="span_dis" href="#discount" uk-toggle><span class="mdi mdi-tag-heart"></span>
         {{get_local_string.string_26}}</a>
         <span class="rabbat" v-show="get_coupon_object.is_apply==1">
         <span>{{get_coupon_object.code}}</span>
            <span><strong class="total_side">{{get_coupon_object.discount_amount}}</strong> {{get_setting_app.payment.currency}}
            </span>
              <b-button class="remove_code" v-if="get_coupon_object.is_apply==1" @click.prevent="remove_coupon_code()" type="is-danger">
                   <ion-icon name="close-sharp"></ion-icon>
                     </b-button>
        </span>
         <router-link class="tilbetailng" to="/Entrees-cart" uk-toggle="target: #offcanvas-flip" >
         <span>{{get_local_string.string_4}}</span>
            <span><strong class="total_side">{{get_final_item_total}}</strong>{{get_setting_app.payment.currency}}
             <del class="del_dis2" v-if="get_coupon_object.is_apply==1" > <strong>{{get_sub_total}}</strong>{{get_setting_app.payment.currency}}</del>
            </span>
            
        </router-link>
            </div>
          <!-- This is the modal -->
<div id="discount" uk-modal>
    <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
         <button class="uk-modal-close-default" type="button" uk-close></button>
     <div class="flex_discount">
        <h1 class="main_dis">{{get_coupon_object.title}}</h1>
         <div class="img_dis">
               <template v-if="get_setting_app.coupon_img">
                     <img :src="get_setting_app.coupon_img" alt="cooupon">
               </template>
               <template v-else>
                      <img :src="get_setting_app.logo" alt="logo">
               </template>
        </div>
        <p class="p1"> {{get_coupon_object.description}}
        </p>
        <p class="p2">{{get_coupon_object.rate}}% {{get_local_string.string_3}}</p>
         <p class="st1"><strong>{{get_local_string.string_1}} {{get_coupon_object.discount_amount}}{{get_setting_app.payment.currency}}</strong></p>
        <div class="cop1">
            <span class="c1">{{get_local_string.string_2}} </span>
            <span class="c2">{{get_coupon_object.code}}</span>
            <!-- {{get_coupon_object}} -->
             <router-link class="tilbetailng" to="/Entrees-cart" uk-toggle="target: #discount" >
         <span>{{get_local_string.string_4}}</span>
            <span><strong class="total_side">{{get_final_item_total}}</strong>{{get_setting_app.payment.currency}}
             <del class="del_dis2" v-if="get_coupon_object.is_apply==1" > <strong>{{get_sub_total}}</strong>{{get_setting_app.payment.currency}}</del>
            </span>
        </router-link>
        </div>
     </div>
    </div>
</div>
            </template>
    </div>
</div>
   </div>
   <!-- modal golbal coupon off -->
 
   </div>
</template>

<script>
 import $ from 'jquery';
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
    name:'sidebar-cart',
    data(){
        return{
            total_price:0,
            local_qty:0,
            show_btn_entree:undefined,
             couopn_input:'',
             errorMsg:'',
        }
       
    },
    computed:{
        ...mapGetters({
            get_data_cart:'get_data_cart',
            // get_grand_total:'get_grand_total',
             all_data_cart:'all_data_cart',
            get_sub_total:'get_sub_total',
            get_setting_app:'get_setting_app',
            authenticated:'auth/authenticated',
            // discoint
              get_coupon_object:'get_coupon_object',
               get_before_dicount:'get_before_dicount',
               get_local_string:'get_local_string',
               get_final_item_total:'get_final_item_total'
        }),
    },

    
    methods:{
        ...mapActions({
            update_data_cart:'update_data_cart',
            delete_data_cart:'delete_data_cart',
            get_data_cartAction:'get_data_cartAction',
            get_setting_api:'get_setting_api',
             apply_coupon_code_api:'apply_coupon_code_api',
            remove_coupon_code_api:'remove_coupon_code_api',
        }),
        ...mapMutations({
            SET_GRAND_TOTAL:'SET_GRAND_TOTAL',
            SET_CART_COUNT :'SET_CART_COUNT'
        }),
        show_option(event){
            event.target.classList.toggle('modify');
        },
         show_option2(event){
             if(event.srcElement.parentNode.classList.contains('modify'))
             {
                  event.srcElement.parentNode.classList.remove('modify')
             }
             else{
                 event.srcElement.parentNode.classList.add('modify')
             }
        },
        hide_side(){
            this.uk.offcanvas($('#offcanvas-flip')).hide();
        },
        updateItem(item , event){
            if(event.target.value == 0 ){
               this.delteItem(item)
            }else{
                   let item_updete = {
             item_id : item.item_id , 
             item_qty: event.target.value
            }
             this.total_price = 0;
             this.local_qty = 0;
              setTimeout(()=>{
               document.querySelectorAll('.move_left_side').forEach((elem)=>{
               this.total_price += (parseFloat( elem.getAttribute('price_data')) * parseFloat(elem.getAttribute('qty')));
               this.local_qty += parseInt(elem.getAttribute('qty'))
           })
            // call animation count 
            // this.animaion_count(this.total_price);
            // end
             this.SET_GRAND_TOTAL(parseFloat(this.total_price));
             this.SET_CART_COUNT(this.local_qty);
             },5)
            // end animation 
            this.update_data_cart(item_updete);
            event.path[5].classList.toggle('modify');
            }
        },
        delteItem(item){
            let item_updete = {
             item_id : item.item_id
            }
            this.delete_data_cart(item_updete);
            // this.total_price = this.get_sub_total - item.item_total;
            // this.animaion_count(this.total_price);
        },
        apply_coupon_code(){
           console.log(this.couopn_input , 'coupon Input');
           this.apply_coupon_code_api(this.couopn_input).then(res=>{
               console.log(res , 'response apply api');
               if(res.status!=200){
                   this.errorMsg = res.message;
                   this.danger();
               }
               else if(res.status==200){
                   $('.input_code input').attr("placeholder",res.data.code);
                     this.couopn_input = res.data.code;
               }
             
           });
       },
        remove_coupon_code(){
           console.log( 'remove coed Input');
           this.apply_coupon_code_api().then(res=>{
               this.couopn_input = '';
               $('.input_code input').attr("placeholder",' Coupon Code ..');
                $('.input_code input').val('');
              
               console.log(res , 'response remove api');
           });
       },
        success() {
          const notif = this.$buefy.notification.open({
              duration: 4000,
              message: this.errorMsg,
              position: 'is-bottom-right',
              type: 'is-success',
              hasIcon: true
          })
          notif.$on('close', () => {
              // this.$buefy.notification.open('Custom notification closed!')
          }
          )
      },
        danger() {
                const notif = this.$buefy.notification.open({
                    duration: 4000,
                    message: this.errorMsg,
                    position: 'is-bottom-right',
                    type: 'is-danger',
                    hasIcon: true
                })
                notif.$on('close', () => {
                    // this.$buefy.notification.open('Custom notification closed!')
                }
                )
            },
    },
    created(){
        if(this.authenticated)
        {
        this.get_data_cartAction();
        if(this.$route.path!='/Entrees-cart')
          {
            //   btn go to entress
               this.show_btn_entree = true;
             console.log('yes this is page watch')
        }
        else{
            // btn go to cart
            this.show_btn_entree = false;
        }
        }
    },
}
</script>

<style lang="scss">
.stky_div{
    position: sticky;
    bottom: 0;
    background-color: var(--side_color);
    z-index: 99;
}
 .control{
        span{
        font-weight: 600;
        font-size: 14px;
        }
    }
     #offcanvas-flip{
          .uk-offcanvas-close {
    position: absolute !important;
    z-index: 1000 !important;
    top: 2px !important;
    right: 10px !important;
    padding: 5px !important;
    background: white !important;
    border-radius: 100% !important;
    padding: 2px !important;
}
    }
.sidebar_close{
    svg{
        display: none !important;
    }
    ion-icon{
        color: #e91e62;
        font-size: 30px;
    }

}
.del_dis2{
    color: #000;
    // position: absolute;
    // right: 14px;
    // top: 14px;
}
.discount_side{
    padding-bottom: 8px;
    border-bottom: 1px solid black;
    margin-bottom: 10px;
}
.remove_code{
    ion-icon{
        font-size:20px;
        font-weight: 600;
        padding-top: 4px;
    }
}
#discount{
    .uk-modal-dialog{
            box-shadow: 0px 0px 8px 0px white;
                max-width: 350px !important;
    }
    // 
    .main_dis{
        text-align: center;
    font-size: 18px;
    font-weight: 700;
    color: #e91e62;
    }
    .img_dis{
text-align: center;
img{
    width: 250px;
    height: 250px;
    object-fit: contain;
}
}
.p1{
    font-size: 14px;
    text-align: center;
    padding-top: 20px;
    font-weight: 500;
    color: #9c9c9c;
    
}
.p2{
    font-size: 50px;
    text-align: center;
    padding-top: 10px;
    font-weight: 600;
    color: #e91e63;
    font-family: 'Rubik Moonrocks', cursive !important;
}
.st1{
    text-align: center;
    font-size: 14px;
    margin-top: -13px;
    margin-bottom: 10px;
}
.cop1{
        display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 10px;
    .c1{
    font-size: 14px;
    font-weight: 500;
    color: #9c9c9c;
    }
    .c2{
        font-size: 20px;
    font-weight: 700;
    padding-top: 5px;
    margin-bottom: 10px;
    }
}
}
</style>
<style lang="scss" scoped>
.abs_delete{
    position: absolute;
     left: -2%;
    bottom: 6px;
    width: 30px !important;
    height: 30px !important;
    border-radius: 100%;
    z-index: 1;
}
.span_dis{
    color: #fff;
    &:hover{
        color: var(--active_color);
    }
}
.input_code{
        flex: 0 0 calc(100% - 80px);
}
.cart_empty , .colsed_wrap{
        position: absolute;
    top: 50%;
    transform: translate(0px, -50%);
    text-align: center;
    p{
        padding-top: 20px;
        color: white;
    }
    a{
        margin-top: 12px;
    }
}
.uk-offcanvas-bar{
    // height: calc(100vh - 124px);
    // top: 124px;
      width: 100% !important;
    top: 0px;
    background-color: #1C0A00;
    border: 1px solid #1C0A00;
    padding: 20px 10px 20px 10px;
     border-width: 0.5px;
     padding-bottom: 0px !important;
}
.rabbat{
  background-color:rgb(12, 12, 12);
    color: #fff;
    width: 100%;
    display: flex;
    padding: 14px 10px;
    justify-content: space-between;
    align-content: center;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 13px;
    transition: 0.2s ease-in-out;
    margin-top: 14px;
    cursor: pointer;  
    position: relative;
    padding-right: 70px;
    strong{
        color: black !important;
    } 
    button{
       position: absolute;
    right: 0;
    top: 0;
    height: 48px;
    z-index: 1;
    border-radius: 0px;
    }
}
.mer{
     background-color:rgb(163, 25, 25);
    color: var(--white_color);
    width: 100%;
    display: flex;
    padding: 14px 10px;
    justify-content: center;
    align-content: center;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 13px;
    transition: 0.2s ease-in-out;
    margin-top: 14px;
    cursor: pointer;
}
.tilbetailng{
   background-color: var(--active_color) !important;
    // background-color: #ec316d;
    color: #000 !important;
    width: 100%;
    display: flex;
    padding: 14px 10px;
    justify-content: space-between;
    align-content: center;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 13px;
    transition: 0.2s ease-in-out;
    margin-top: 10px;
    // padding-right: 60px;
    position: relative;
    &:hover{
         color: #000;
    }
}
.single_side:first-child{
    border-bottom: 0px;
    margin-top: 14px;
}
.move_left.modify{
        transform: translate3d(-4.375rem, 0, 0);
        img{
            opacity: 0;
        }
        .price_side{
            opacity: 0;
        }
        aside{
      -webkit-transform: translate3d(-2.8rem, 0, 0);
    transform: translate3d(-2.8rem, 0, 0);
    opacity: 1;
    z-index: 1;
    display: block;
    pointer-events:auto;
        }
}
.remove_item{
    width: 2.5rem;
    height: 2.5rem;
    margin-left: 0.5rem;
    background-color: #d20a11;
    color: white;
    outline: none;
    border: none;
}
.single_side{
      border-top: 1px solid rgb(180, 180, 180);
        display: block;
        position: relative;
    .move_left{
   display: flex;
    align-items: center;
    padding: 5px;
    border-width: 0.5px;
    transition: -webkit-transform 0.4s cubic-bezier(0.23, 1, 0.32, 1);
    transition: transform 0.4s cubic-bezier(0.23, 1, 0.32, 1);
    color: black;
        }
        aside{
    position: absolute;
    right: -6.625rem;
    top: 20px;
    opacity: 0;
    transition: -webkit-transform 0.4s cubic-bezier(0.23, 1, 0.32, 1),opacity 0.1s linear;
    transition: transform 0.4s cubic-bezier(0.23, 1, 0.32, 1),opacity 0.1s linear;
    pointer-events: none;
    display: none;
        }
    img{
        width: 72px;
        height: 72px;
        object-fit: contain;
        transition: opacity 0.15s linear;
    }
    .name_side{
    padding-left: 10px;
    font-size: 12px;
    padding-right: 11px;
   flex: 0 0 calc(100% - 120px);
   color: #000;
    }
    .price_side{
        font-weight: 700;
        font-size: 13px;
         transition: opacity 0.15s linear;
         color: #000;
    }
}
.list_added_item{
   min-height: calc(100vh - 140px);
    //    height: calc(100vh - 140px);
    overflow-y: auto !important;
    padding-bottom: 30px;
}
.list_added_item.side_in{
 min-height: calc(100vh - 140px);
    //    height: calc(100vh - 140px);  
}
.uk-offcanvas-overlay::before {

    background: rgb(0 0 0 / 53%);
}

@media(max-width:992px){
    .single_side .name_side {
    padding-left: 8px !important;
    font-size: 11px !important;
    padding-right: 8px;
    flex: 0 0 calc(100% - 100px) !important;
}
.single_side img[data-v-6274afaf] {
    width: 50px !important;
    height: 50px !important;
}
#offcanvas-flip .uk-offcanvas-bar{
        padding: 20px 8px !important;
        padding-bottom: 0px !important; 
        // pd -0
}
}
@media(max-width:767px){
    .abs_delete{
     position: absolute;
    left: 0%;
    width: 20px !important;
    height: 20px !important;
    border-radius: 100%;
    z-index: 1;
    padding: 4px;
    margin-left: 0;
    bottom: 6px;
    font-size: 12px;
}
}
</style>